import { OnboardingStepName } from './OnboardingDTO';

interface OnboardingStepsState {
  steps?: Record<string, { status?: string } | null> | null;
}

interface MergeOnboardingStepParams<T extends OnboardingStepsState> {
  current: T | undefined;
  stepName: OnboardingStepName;
  status: 'completed' | 'skipped' | 'started';
}

export function mergeOnboardingStep<T extends OnboardingStepsState>({
  current,
  stepName,
  status,
}: MergeOnboardingStepParams<T>): T | undefined {
  if (!current?.steps) {
    return current;
  }

  return {
    ...current,
    steps: {
      ...current.steps,
      [stepName]: { status },
    },
  };
}
